/* @flow */
import MorphRight from './CTA13_morph_right'
import MorphBottom from './CTA13_morph_bottom'
import MorphLeft from './CTA13_morph_left'
export const DECORATIONS = [MorphLeft, MorphBottom, MorphRight]
